import React, { Component, Fragment } from "react";
import { connect } from "react-redux"
import LandingPage from "../../Component/LandingPage/LandingPage";
import * as actionCreators from "../../Store/actions/index";
import { withRouter } from "react-router-dom";
import BottomToolBar from "../../Component/Navigation/BottomToolBar/BottomToolBar";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import Authentication from "../Authentication/Authentication";
import ContactNow from "../../Component/ContactNow/ContactNow";
class Landing extends Component {

    state = {
        searchInput: '',
        showAuth: false,
        authMode: 'signIn'
    }


    componentDidMount() {
        this.props.onChangeVehicleType('all');
        localStorage.setItem('vehicleType', 'all');
        this.props.onGetFeatruedVehicles('all');
        this.props.onGetFeaturedDealers();
    }

    featuredTypeHandler = (type) => {
        this.props.onGetFeatruedVehicles(type);
        this.props.onChangeVehicleType(type)
    }

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }

    reLoadSearchPageHandler = () => {
        //  console.log('tes')
    }

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    render() {
        let FeatruedVehicles = this.props.FeatruedVehicles ? this.props.FeatruedVehicles : [];
        let FeatruedDealers = this.props.feauredDealers ? this.props.feauredDealers : [];
        return (
            <Fragment>
                {this.state.showAuth ?
                    <Authentication
                        showAuth={this.state.showAuth}
                        showAuthHandler={this.showAuthHandler}
                        authMode={this.state.authMode} />
                    :
                    null}
                <MainToolBar
                    searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user} />
                <BottomToolBar changeType={(type) => { this.props.onChangeVehicleType(type) }} />
                <LandingPage
                    FeatruedVehicles={FeatruedVehicles}
                    FeatruedDealers={FeatruedDealers}
                    loadingFeature={this.props.loadingFeature}
                    loadingDealers={this.props.loadingDealers}
                    getFeatured={(type) => { this.featuredTypeHandler(type) }}
                    vehicleType={localStorage.getItem('vehicleType')}
                    routeHistory={this.props.history}
                    wishIdsArray={this.props.wishIdsArray}
                    user={this.props.user}
                    AddItemToUserWishList={this.props.onAddItemToUserWishList}
                    showAuthHandler={this.showAuthHandler}
                    addingItem={this.props.addingItem}
                    commingSoon={this.props.commingSoon}
                />
                <ContactNow />
            </Fragment>


        );
    }
}

const mapStateToProps = state => {
    return {
        FeatruedVehicles: state.landingP.feauredVechils,
        loadingFeature: state.landingP.loadingFeature,
        errorFeaured: state.landingP.errorFeauredVechils,
        feauredDealers: state.landingP.feauredDealers,
        loadingDealers: state.landingP.loadingDealers,
        //comming Soon :
        commingSoon : state.landingP.commingSoon,
        //Search related :
        vehicleType: state.SearchP.vehicleType,
        // Auth related : 
        user: state.Auth.user,
        // WishList related : 
        wishIdsArray: state.WishList.wishIdsArray,
        addingItem: state.WishList.addingItem
    }

};

const mapDispathToPrpos = dispatch => {
    return {
        onGetFeatruedVehicles: (type) => { dispatch(actionCreators.getFeaturedVehicle(type)) },
        onGetFeaturedDealers: () => { dispatch(actionCreators.getFeaturedDealers()) },
        onChangeVehicleType: (type) => { dispatch(actionCreators.changeVehicleType(type)) },
        onAddItemToUserWishList: (itemId, token) => { dispatch(actionCreators.addItemToUserWishList(itemId, token)) }
    }
};
export default withRouter(connect(mapStateToProps, mapDispathToPrpos)(Landing));

